import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ModalService } from '@app/core/services/modal.service';
import { SrOperationArGet, SrOperationResourceItem, SrOperationSelectableResource, SrOperationService } from '@app/services/sr-operation.service';

@Component({
    selector: 'tt-sr-operation-ar',
    templateUrl: './sr-operation-ar.component.html',
    styleUrls: ['./sr-operation-ar.component.css'],
    standalone: false,
})
export class SrOperationArComponent implements OnInit {
    public page?: SrOperationArGet;
    public superiors: SrOperationResourceItem[] = [];
    public resources: SrOperationSelectableResource[] = [];
    public saving = false;
    private loadVersion = 0;

    constructor(
        private readonly operation: SrOperationService,
        private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.page = await this.operation.getResourceSelection({ custact_no: String(this.navigator?.params['custact_no'] ?? '') });
        const [superiors] = await Promise.all([this.operation.getSuperiorResources(), this.loadResources()]);
        this.superiors = superiors;
    }

    public async onSuperiorChanged(value: string): Promise<void> {
        if (!this.page || this.page.resource_id_superior === value) return;
        this.page.resource_id_superior = value;
        await this.loadResources();
    }

    public async onAlertDateChanged(value: string): Promise<void> {
        if (!this.page || this.page.first_alert_dt === value) return;
        const previous = this.page.first_alert_dt;
        this.page.first_alert_dt = value;
        if (previous !== undefined && previous.length <= 16 && value.length <= 16) await this.loadResources();
    }

    private async loadResources(): Promise<void> {
        const version = ++this.loadVersion;
        if (!this.page?.resource_id_superior?.trim() || !this.page.first_alert_dt?.trim()) return;
        this.resources = [];
        const resources = await this.operation.getSelectableResources({ ...this.page });
        if (version === this.loadVersion) this.resources = resources;
    }

    public toggleChosen(item: SrOperationSelectableResource): void {
        if (item.item_id === '0' || item.item_id === '-1') return;
        const resource = this.resources.find(resource => resource.item_id === item.item_id);
        if (!resource) return;
        resource.item_is_selected = resource.item_is_selected === '0' ? '1' : '0';
        this.resources = [...this.resources];
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        try {
            // Legacy saving includes selected rows outside the visible filter.
            const records = this.resources.filter(item => item.item_filtervalue !== undefined && item.item_id !== '0' && item.item_id !== '-1' && item.item_is_selected !== '0')
                .map(({ item_id, item_is_selected }) => ({ item_id, item_is_selected }));
            const response = await this.operation.addResources({ ...this.page, records });
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.saving = false; }
    }

    private showWarning(message: string): Promise<void> {
        return this.modal.show({ type: 'warning', title: 'Varsel', message, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
    }
}
